import React from 'react';

import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
// import Collapse from '@material-ui/core/Collapse';
// import ExpandLess from '@material-ui/icons/ExpandLess';
// import ExpandMore from '@material-ui/icons/ExpandMore';
import TwitterIcon from '@material-ui/icons/Twitter';
// import PeopleIcon from "@material-ui/icons/People";
// import SportsSoccerIcon from "@material-ui/icons/SportsSoccer";
// import MuseumIcon from '@material-ui/icons/Museum';
// import LibraryMusicIcon from '@material-ui/icons/LibraryMusic';
// import TranslateIcon from "@material-ui/icons/Translate";
// import InsertChartIcon from '@material-ui/icons/InsertChart';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { Link } from 'react-router-dom'

const drawerWidth = 200;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },  
}));

function ResponsiveDrawer(props) {
  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  // const [open, setOpen] = React.useState(true);

  // const handleClick = () => {
  //   setOpen(!open);
  // };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleDrawerClose = () => {
    setMobileOpen(false);
  };

  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <Divider />
      <List>
        <ListItem button component={Link} to="/" onClick={handleDrawerClose}>
          <ListItemIcon>
            <TwitterIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={"ツイッター"} />
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem button component="a" href="https://football-sns.net/football/">
          <ListItemText primary={"フットボールワード"} />
        </ListItem>
      </List>
      <List>
        <ListItem button component="a" href="https://football-sns.net/basic/">
          <ListItemText primary={"基礎ワード"} />
        </ListItem>
      </List>
      <List>
        <ListItem button component="a" href="https://football-sns.net/grammar/">
          <ListItemText primary={"基礎文法"} />
        </ListItem>
      </List>
      <List>
        <ListItem button component="a" href="https://football-sns.net/tw/">
          <ListItemText primary={"ツイートセレクト"} />
        </ListItem>
      </List>
      {/* <ListItem button onClick={handleClick}>
        <ListItemIcon>
          <InsertChartIcon color="primary" />
        </ListItemIcon>
        <ListItemText primary="統計/Stats" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            button
            component={Link}
            to="/stats/playernation"
            className={classes.nested}
            onClick={handleDrawerClose}
          >
            <ListItemIcon>
              <PeopleIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="国籍統計" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/stats/shoot"
            className={classes.nested}
            onClick={handleDrawerClose}
          >
            <ListItemIcon>
              <SportsSoccerIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="シュート" />
          </ListItem>
        </List>
      </Collapse>

      <Divider />
      <ListItem button onClick={handleClick}>
        <ListItemIcon>
          <MuseumIcon color="primary" />
        </ListItemIcon>
        <ListItemText primary="諸国の文化" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            button
            component={Link}
            to="/language"
            className={classes.nested}
            onClick={handleDrawerClose}
          >
            <ListItemIcon>
              <TranslateIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="言語" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/music"
            className={classes.nested}
            onClick={handleDrawerClose}
          >
            <ListItemIcon>
              <LibraryMusicIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="音楽" />
          </ListItem>
        </List>
      </Collapse> */}
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            語楽フットボール
          </Typography>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </main>
    </div>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;
